import { getPaymentMethodSession, pay } from 'src/common/facades/eagle/checkout';
import { getCookies } from 'src/client/js/facades/eagle/helpers/cookies';
import { localiseUrl } from 'src/common/utils/format-localised-url';

import logger from 'src/logger';

export const createPaypalSession = async (paymentMethodName) => {
  const { orderId } = await getPaymentMethodSession(paymentMethodName, getCookies());
  return orderId;
};

/**
 *
 * @param {string} paymentMethodName method name that eagle knows about
 * @param {string} paypalOrderId as created by Paypal
 * @param {string} paypalPayerId Paypal's customer ID
 * @param {CountryModel} countryModel
 */
export const completePayment = async (paymentMethodName, paypalOrderId, paypalPayerId, countryModel) => {
  const { orderNumber } = await pay(paymentMethodName, getCookies(),
    { orderId: paypalOrderId, payerId: paypalPayerId });
  window.location = localiseUrl(countryModel, `/orders/${orderNumber}`);
};

/**
 *
 * @param {string} clientId required to load Paypal Checkout
 * @param {string} locale optional arg to
 * @param {string} currency Paypal's customer ID
 */
export const buildPaypalSdkUrl = (clientId, locale, currency) => {
  if (!clientId) {
    logger.error(`Paypal client id is falsey. Payment method cannot be loaded. `+
      `CUR=${currency} LOC=${locale} CID=${clientId}`);
    return null;
  }
  const paypalLocale = locale && locale.replace('-', '_');
  return `https://www.paypal.com/sdk/js?`+
  `intent=authorize`+
  `&client-id=${clientId}`+
  // Optional args follow:
  `${paypalLocale ? `&locale=${paypalLocale}` : ''}`+
  `${currency ? `&currency=${currency}` : ''}`;
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaypalCheckoutButton/helpers.js